import React from 'react';
import { MetricCardProps } from '../../types/visualization';

const MetricCard: React.FC<MetricCardProps> = ({ 
  value, 
  title, 
  description, 
  color = '#3b82f6' 
}) => {
  return (
    <div style={{ textAlign: 'center', padding: '40px 20px' }}>
      <div style={{ 
        fontSize: '48px', 
        fontWeight: 'bold', 
        color, 
        marginBottom: '8px' 
      }}>
        {String(value)}
      </div>
      <div style={{ 
        fontSize: '16px', 
        color: '#6b7280', 
        textTransform: 'capitalize' 
      }}>
        {title}
      </div>
      {description && (
        <div style={{ 
          fontSize: '12px', 
          color: '#9ca3af', 
          marginTop: '8px' 
        }}>
          {description}
        </div>
      )}
    </div>
  );
};

export default MetricCard; 